"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_PractitionerRole_AvailableTime = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_code_1 = require("../Scalar/RTTI_code");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_time_1 = require("../Scalar/RTTI_time");
exports.RTTI_PractitionerRole_AvailableTime = t.recursion('IPractitionerRole_AvailableTime', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        daysOfWeek: t.array(RTTI_code_1.RTTI_code),
        _daysOfWeek: t.array(RTTI_Element_1.RTTI_Element),
        allDay: t.boolean,
        _allDay: RTTI_Element_1.RTTI_Element,
        availableStartTime: RTTI_time_1.RTTI_time,
        _availableStartTime: RTTI_Element_1.RTTI_Element,
        availableEndTime: RTTI_time_1.RTTI_time,
        _availableEndTime: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_PractitionerRole_AvailableTime.js.map